import { type FC, useMemo } from 'react';

import { Box, Tab, TabList, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ADMIN_PATH } from '@/features/admin';

export const AdminSettingsCommunicationLayout: FC = () => {
  const { t } = useTranslation(['components']);
  const navigate = useNavigate();
  const location = useLocation();

  const TABS = [
    {
      id: 'email',
      label: t('components:settings.account.emails.emailTemplates'),
      linkTo: `${ADMIN_PATH}/settings/communication/emails`,
    },
    {
      id: 'sms',
      label: t('components:smsSettings.smsSettings'),
      linkTo: `${ADMIN_PATH}/settings/communication/sms`,
    },
    {
      id: 'reminder-call',
      label: t('components:reminderCallSettings.reminderCallSettings'),
      linkTo: `${ADMIN_PATH}/settings/communication/reminder-call`,
    },
    {
      id: 'whatsapp-settings',
      label: t('components:whatsappSettings.whatsappSettings'),
      linkTo: `${ADMIN_PATH}/settings/communication/whatsapp`,
    },
  ] as const;

  const activeIndex = useMemo(
    () => TABS.findIndex((tab) => location.pathname.startsWith(tab.linkTo)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  );

  return (
    <Tabs
      position="relative"
      variant="unstyled"
      index={activeIndex}
      onChange={(index) => navigate(TABS[index]!.linkTo)}
    >
      <TabList
        bg="gray.25"
        borderRadius="12px"
        border="1px solid"
        borderColor="gray.50"
        p={1}
        w="fit-content"
      >
        {TABS.map((tab) => (
          <Tab
            key={tab.id}
            fontWeight="semibold"
            _selected={{
              bg: 'white',
              color: 'brand.500',
              borderRadius: '12px',
              border: '1px solid',
              borderColor: 'gray.100',
              fontWeight: 'semibold',
            }}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        <Box px={0} pt={6} pb={0}>
          <Outlet />
        </Box>
      </TabPanels>
    </Tabs>
  );
};
